"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startPoll = exports.stopPoll = void 0;
const request_1 = require("@/utils/api/request");
var PollStatuses;
(function (PollStatuses) {
    PollStatuses[PollStatuses["Stopped"] = 0] = "Stopped";
    PollStatuses[PollStatuses["Active"] = 1] = "Active";
})(PollStatuses || (PollStatuses = {}));
async function pollStatusRequest(pollId, status) {
    const { data, error } = await (0, request_1.request)("/foquz/api/poll/change-active", {
        method: "POST",
        params: {
            id: pollId,
        },
        body: {
            status,
        },
    });
    if (error)
        throw new Error(error);
    return data;
}
function stopPoll(pollId) {
    return pollStatusRequest(pollId, PollStatuses.Stopped);
}
exports.stopPoll = stopPoll;
function startPoll(pollId) {
    return pollStatusRequest(pollId, PollStatuses.Active);
}
exports.startPoll = startPoll;
